export const MINUTES_IN_HOUR = 60;
export const SECONDS_IN_MINUTE = 60;
export const NAVIGATION_BAR_CLOCK_INTERVAL = 5000;
export const MILLISECONDS_IN_DAY = 86400000;
export const ONE_MINUTE: number = SECONDS_IN_MINUTE;
export const TWO_MINUTES: number = SECONDS_IN_MINUTE * 2;
export const MIXPANEL_AVERAGE_SESSION_TIME: number = 1800000;